import { useState, useEffect } from 'react'
import './Filter.css'

function Filter(props) {
    const [showMonth, setShowMonth] = useState("")

    // get todays month
    useEffect(() => {
        // if no month chosen (app just started or restarted), set todays month
        const getTodaysMonth = () => {
            const date = new Date()
            const todaysMonthInNumber = date.getMonth()
            props.setChosenMonth(todaysMonthInNumber)
        }
        if (props.chosenMonth === 99) getTodaysMonth()
    }, [props])
  
    // make todays month to string for displaying
    useEffect(() => {
      if (props.chosenMonth === 0) setShowMonth("Januari")
      if (props.chosenMonth === 1) setShowMonth("Februari")
      if (props.chosenMonth === 2) setShowMonth("Mars")
      if (props.chosenMonth === 3) setShowMonth("April")
      if (props.chosenMonth === 4) setShowMonth("Maj")
      if (props.chosenMonth === 5) setShowMonth("Juni")
      if (props.chosenMonth === 6) setShowMonth("Juli")
      if (props.chosenMonth === 7) setShowMonth("Augusti")
      if (props.chosenMonth === 8) setShowMonth("September")
      if (props.chosenMonth === 9) setShowMonth("Oktober")
      if (props.chosenMonth === 10) setShowMonth("November")
      if (props.chosenMonth === 11) setShowMonth("December")
    }, [props.chosenMonth])

    // go to prev month click
    const getPrevMonth = () => {
        if (props.chosenMonth === 0) props.setChosenMonth(11)
        else props.setChosenMonth(props.chosenMonth - 1)
    }

    // go to next month click
    const getNextMonth = () => {
        if (props.chosenMonth === 11) props.setChosenMonth(0)
        else props.setChosenMonth(props.chosenMonth + 1)
    }

    return (
        <div className="filter">
            <div>
                <img 
                    src="/img/arrow-left.ico"
                    alt="Arrow back" 
                    onClick={getPrevMonth} 
                />

            </div>
            <div>{showMonth}</div>
            <div>
                <img
                    src="/img/arrow-right.ico"
                    alt="Arrow forward"
                    onClick={getNextMonth}
                />
            </div>
        </div>
    )
}

export default Filter